// extracted by mini-css-extract-plugin
module.exports = {"lines":"HeaderBanner_lines__2-DV6"};